import { Backdrop, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Paper, TextField, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import MaterialTable from '@material-table/core';
import { Edit, Save } from '@material-ui/icons';
import axios_instance from '../../../services/auth/jwt/config';
import sweetAlert from '../../../f5/utils/sweetAlert';
import { tableIcons, tableLocalization } from '../../../@jumbo/constants/TableConstants';

interface DepartamentIndexProps {

}

type Departament = {
    id: number,
    nome: string,
    email: string,
}

export default function DepartamentIndex({ ...props }: DepartamentIndexProps) {
    const [departamentos, setDepartamentos] = useState<Departament[]>([]);
    const [sending, setSending] = useState(false);
    const [loading, setLoading] = useState(true);
    const [editing, setEditing] = useState({
        open: false, data: {
            nome: '',
            email: '',
            id: 0,
        }
    });

    const onLoad = () => {
        setLoading(true);
        axios_instance.get<{ success: boolean, items: Departament[], message: string }>(`ouvidoria/auxiliar/departamento?dep=1`).then((response) => {
            let r = response.data;
            if (r.success) {
                setDepartamentos(r.items)
            } else {
                sweetAlert('error', 'Erro ao carregar departamentos', r.message)
            }
        }).catch((error) => {
            sweetAlert('error', 'Erro ao carregar departamentos', error.message)
        }).finally(() => {
            setLoading(false);
        })
    }

    useEffect(() => {
        onLoad()
    }, [])

    const onSave = (data: Departament) => {
        setSending(true);
        setEditing({
            open: false, data: {
                nome: '',
                email: '',
                id: 0,
            }
        });
        if (data.id === 0) {
            sweetAlert('error', 'Erro ao salvar', 'ID inválido');
            setSending(false);
            setEditing({
                open: false, data: {
                    nome: '',
                    email: '',
                    id: 0,
                }
            });
            return;
        }
        axios_instance.post<{ success: boolean }>(`ouvidoria/crud/departamento/${data.id}`, {
            nome: data.nome,
            email: data.email,
        }).then((response) => {
            let r = response.data;
            if (r.success) {
                onLoad()
            }
        }).catch((error) => {
        }).finally(() => {
            setSending(false);
        })
    }
    //@ts-ignore
    return <PageContainer>
        <Backdrop open={sending} style={{ zIndex: 9999 }}>
            <Box display="flex" flexDirection="column" alignItems="center" color="white" gridGap={2}>
                <CircularProgress color="inherit" />
                <Typography variant="h4" color="inherit">Salvando...</Typography>
            </Box>
        </Backdrop>
        <MaterialTable
            title="Departamentos"
            columns={[
                { title: 'Nome', field: 'nome' },
                { title: 'E-mail', field: 'email' },
            ]}
            isLoading={loading}
            actions={[
                {
                    icon: () => <Edit />, onClick: (event, rowData) => {
                        //@ts-ignore
                        setEditing({ open: true, data: rowData });
                    }, tooltip: 'Editar'
                },
            ]}
            options={{
                actionsColumnIndex: -1,
                pageSize: 10,
            }}
            data={departamentos}
            localization={tableLocalization}
            icons={tableIcons}
        />
        <Dialog open={editing.open} onClose={() => setEditing({
            open: false, data: {
                nome: '',
                email: '',
                id: 0,
            }
        })} maxWidth="md" fullWidth>
            <DialogTitle>Editar Departamento</DialogTitle>
            <DialogContent>
                <TextField
                    label="Nome"
                    value={editing.data.nome}
                    onChange={(e) => setEditing({ ...editing, data: { ...editing.data, nome: e.target.value } })}
                    fullWidth
                    variant="outlined"
                    margin="normal"
                />
                <TextField
                    label="E-mail"
                    value={editing.data.email}
                    onChange={(e) => setEditing({ ...editing, data: { ...editing.data, email: e.target.value } })}
                    fullWidth
                    variant="outlined"
                    margin="normal"
                />
            </DialogContent>
            <DialogActions>
                <Box display="flex" justifyContent="space-between" width="100%">
                    <Button
                        variant='contained' color="secondary"
                        onClick={() => setEditing({
                            open: false, data: {
                                nome: '',
                                email: '',
                                id: 0,
                            }
                        })}
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant='contained'
                        onClick={() => onSave(editing.data)}
                        startIcon={<Save />}
                        style={{ backgroundColor: '#4caf50', color: 'white' }}
                    >
                        Salvar
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    </PageContainer>
}